import XAPPService from "app/Core/services/XAPPService";
export const GET_EMPRESATAGS = "{EMPRESATAG APP] GET TAGS";
export const GET_EMPRESATAG = "{EMPRESATAG APP] GET TAG";
export const GET_TEMPLATE = "{EMPRESATAG APP] GET TEMPLATE";

export const OPEN_NEW_EMPRESATAG_DIALOG = "{EMPRESATAG APP] OPEN NEW TAG DIALOG";
export const CLOSE_NEW_EMPRESATAG_DIALOG = "{EMPRESATAG APP] CLOSE NEW TAG DIALOG";
export const OPEN_EDIT_EMPRESATAG_DIALOG = "{EMPRESATAG APP] OPEN EDIT TAG DIALOG";
export const CLOSE_EDIT_EMPRESATAG_DIALOG = "{EMPRESATAG APP] CLOSE EDIT TAG DIALOG";

export const EMPRESATAG_REMOVE = "{EMPRESATAG APP] TAG REMOVE";
export const ADD_EMPRESATAG = "{EMPRESATAG APP] ADD TAG";

export const EMPRESATAG_WARNING = "{EMPRESATAG APP] TAG WARNING";
export const EMPRESATAG_INFO = "{EMPRESATAG APP] TAG INFO";
export const EMPRESATAG_ERROR = "{EMPRESATAG APP] TAG ERROR";
export const EMPRESATAG_SELECIONAR_WARNING = "{EMPRESATAG APP] TAG SELECIONAR WARNING";
export const EMPRESATAG_SELECIONAR_INFO = "{EMPRESATAG APP] TAG SELECIONAR INFO";
export const EMPRESATAG_SELECIONAR_ERROR = "{EMPRESATAG APP] TAG SELECIONAR ERROR";


const ListState =
    [
        "idpessoaformulario",
        "idpessoa",
        "idparent",
        "nome",
        "cor",
        "cordescricao",
        "formulario",
        "statusregistro",
        "statusregistrodescricao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao",
        "totalrows",
        "paginas",
    ];

const AddState =
    [
        "idparent",
        "formulario",
        "idpessoa",
        "tipo",
    ];

const UpdateState =
    [
        "formulario"
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Tag", AActions, "spvwempresatag", ListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESATAG,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAG_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Tags", AActions, "spvwempresatag", ListState, _AAction, AConditionsAND, AConditionsOR, _APagina);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESATAGS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAG_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESATAG_DIALOG
    };
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESATAG_DIALOG
    };
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESATAG_DIALOG,
        data
    };
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESATAG_DIALOG
    };
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESATAG_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESATAG_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESATAG_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction("pessoa", "120")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAG_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESATAG_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAG_ERROR,
                    payload: error
                });
            });
    };
}


export function clearReducer() {
    return {
        type: GET_EMPRESATAGS,
        data: null,
        pagina: 1,
    };
}